import {Nullish} from 'shared/web';

import {i18n} from '../i18n/i18n';
import {isCebiaWorkspace} from './isCebiaWorkspace';

const OIL_DROP_SUGGESTION_SEPARATOR = ' - ';

export function getOilDropTestDescription(comment: string | Nullish) {
  if (isCebiaWorkspace()) {
    if (comment) {
      return `${comment}${OIL_DROP_SUGGESTION_SEPARATOR}${i18n.t('oilDropTestReplacementSuggestion')}`;
    }
    return i18n.t('oilDropTestReplacementSuggestion');
  }

  return comment;
}
